function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import commonMixin from './mixins/common';
import { getTitle } from './utils';
var __vue_script__ = {
  name: 'MenuItemGroup',
  mixins: [commonMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    paddingStyle: function paddingStyle() {
      var level = this.level,
          isInlineMode = this.isInlineMode,
          inlineIndent = this.inlineIndent;

      if (!isInlineMode) {
        return {};
      }

      return {
        paddingLeft: level * inlineIndent - inlineIndent / 2
      };
    },
    classes: function classes() {
      var rootPrefixCls = this.rootPrefixCls;
      return _defineProperty({}, "".concat(rootPrefixCls, "-item-group"), true);
    },
    titleClasses: function titleClasses() {
      var rootPrefixCls = this.rootPrefixCls;
      return _defineProperty({}, "".concat(rootPrefixCls, "-item-group-title"), true);
    },
    listClasses: function listClasses() {
      var rootPrefixCls = this.rootPrefixCls;
      return _defineProperty({}, "".concat(rootPrefixCls, "-item-group-list"), true);
    }
  },
  created: function created() {
    this.rootMenu.addDescendants(this);
  },
  beforeDestroy: function beforeDestroy() {
    this.rootMenu.removeDescendants(this);
  },
  methods: {
    getAttrTitleVal: function getAttrTitleVal(slotTitle, title) {
      var hasTitleAttr = this.hasTitleAttr;
      return hasTitleAttr ? getTitle(slotTitle, title) : '';
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    class: _vm.classes,
    attrs: {
      "title": _vm.getAttrTitleVal(_vm.$slots.title, _vm.title)
    }
  }, [_c('div', {
    class: _vm.titleClasses,
    style: _vm.paddingStyle
  }, [_vm._t("title", [_vm._v(_vm._s(_vm.title))])], 2), _vm._v(" "), _c('ul', {
    class: _vm.listClasses
  }, [_vm._t("default")], 2)]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "menuItemGroup.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);